<template>
  <div class="card shadow">
    <div class="card-header bg-transparent">
      <div>
        <h3 class="mb-0">
          {{ $tc('message.activite.titre',1) }}
        </h3>
      </div>
    </div>
    <div class="card-body">
    <b-container>
      <b-row class="">
        <b-col sm="7"></b-col>
        <b-col sm="5" class="text-right" v-if="can">
          <b-button
              variant="outline-primary"
              class="mb-2"
              size="sm"
              @click="cloturerActivite"
          >
            {{ $t('message.cloturer') }}
          </b-button>

          <b-button
              variant="outline-warning"
              size="sm"
              class="mb-2"
              @click="editActivity"

          >
            {{ $t('message.edit') }}
          </b-button>
          <b-button
              variant="outline-danger"
              class="mb-2"
              size="sm"
              v-b-modal.delete-modal
          >
            {{ $t('message.delete') }}
          </b-button>

        </b-col>
      </b-row>
      <b-modal
          id="delete-modal"
          size="sm"
          header-bg-variant="danger"
          header-text-variant="light"
          :title="$t('message.delete') + ' ' + $tc('message.activites',1)"
          hide-footer
      >
        <div class="d-block text-center">
          <h3>{{ $t('message.delete') }} {{ nom+' '+$t('message.of')+' ' +showDateCloture }}?</h3>
        </div>

        <div class="d-block float-right">
          <b-button variant="danger" @click="deleteActivite">
            {{ $t('message.delete') }}
          </b-button>

          <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
            {{ $t('message.cancel') }}
          </b-button>
        </div>
      </b-modal>
    </b-container>

    <b-container>
      <h3 class="heading text-center mt-3 mb-3">{{$t('message.information.generale')}}</h3>

      <b-row>
        <div class="col-12">
          <div class="timeline-box h-100">
            <div class="box-title">
              <i class="fa fa-list" aria-hidden="true"></i>
              {{ $t('message.detail.activite') }}
            </div>
            <div class="box-content">
              <div class="box-item column-display-style column-display-style-without-mb">
                <div class="row">
                  <div class="col-6 text-right">
                    <p><strong>{{ $t('message.groupeActivite') }}</strong></p>
                  </div>
                  <div class="col-6 text-left">
                    <p>{{ nom }}</p>
                  </div>

                  <div class="col-6 text-right">
                    <p><strong>{{ $t('message.cloture') }}</strong></p>
                  </div>
                  <div class="col-6 text-left">
                    <p>{{ statut == true ? $t('message.yes') :$t('message.no') }}</p>
                  </div>
                  <div class="col-6 text-right">
                    <p><strong>{{ $t('message.dateCloture') }}</strong></p>
                  </div>
                  <div class="col-6 text-left">
                    <p>{{ showDateCloture }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-5 mb-5">
          <div class="timeline-box h-100">
            <div class="box-title">
              <i class="fa fa-list" aria-hidden="true"></i>
              {{ $t('message.detail.mission') }}
            </div>
            <div class="box-content">
              <div class="box-item column-display-style column-display-style-without-mb">
                <div class="row">
                  <b-table
                      striped
                      responsive
                      hover
                      bordered
                      :items="missions"
                      :fields="selectedMissionsField"
                  >
                    <template v-slot:cell(description)="data">
                      <p class="mb-0">{{ getDescription(data.value) }}</p>
                    </template>
                    <template v-slot:cell(statut)="data">
                      <p class="mb-0">{{ data.value == true || data.value == 1  ? $t('message.yes') : $t('message.no')}}</p>
                    </template>
<!--                    <template v-slot:cell(dossier_medical_id)="data">-->
<!--                      <p class="mb-0">{{ getNomPatient(data.value) }}</p>-->
<!--                    </template>-->
                    <!--                    <template v-slot:cell(action)="data">-->
                    <!--                      <b-button @click="supprimerMission(data)"  class="btn-sm btn-outline-danger" >-->
                    <!--                        {{ $t('message.delete') }}-->
                    <!--                      </b-button>-->
                    <!--                    </template>-->
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </b-container>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from  'moment';
import i18n from "@/plugins/i18n";
import _ from "lodash";
export default {
  name: "Show",
  computed: {
    ...mapGetters(["activite", 'hasAdminRole',
      'hasGestionnaireRole', 'hasPraticienRole', 'hasMedecinControleRole','hasAssistante']),

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasAssistante;
    },
    nom:function (){
      if (this.activite.hasOwnProperty('groupe')){
        return  this.activite.groupe.nom;
      }
      return '';
    },
    statut:function (){
      if (this.activite)
        return this.activite.statut;
      return null;
    },
    showDateCloture:function(){
      let date = this.activite.date_cloture;
      return date != null ?   moment(date).format('DD-MM-YYYY') :  i18n.t('message.nonDefinie');
    },

    missions:function (){
      let mArray = [];
      _.forEach(this.activite.missions, function (mission){
        let item = mission;
        let text = '';
        if (!_.isNull(mission.dossier)) {

          let prenom = mission.dossier.patient.user.prenom ? mission.dossier.patient.user.prenom : '';
          prenom = prenom.toLowerCase();
          text = (mission.dossier.patient.user.nom).toUpperCase() + " " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
          item.nom_patient = text;
        }
        mArray.push(item);

      });

      return mArray;
    },

    selectedMissionsField:function (){
      let self = this;
      let sArray = [];
      sArray.push({key: 'description', label: this.$i18n.t('message.description')});
      sArray.push({key: 'commentaire', label: this.$i18n.tc('message.commentaires',1)});
      sArray.push({key: 'statut', label: this.$i18n.t('message.cloture')});
      sArray.push({key: 'date_cloture', label: this.$i18n.t('message.dateCloture')});
      if (self.activite.groupe_id === 1 || self.activite.groupe_id === 2){
        sArray.unshift({key: 'nom_patient', label: this.$i18n.t('message.nomPatient')});
      }
      if (self.activite.groupe_id === 3){
        sArray.unshift({key: 'nom_partenaire', label: this.$i18n.t('message.nomPartenaire')});
      }
      else if (self.activite.groupe_id === 4){
        sArray.unshift({key: 'nom_activite', label: this.$i18n.t('message.activite.nom')});
      }
      // sArray.push({key: 'action', label: this.$i18n.t('message.action')});
      return sArray;
    }
  },
  data(){
    return {
      activite_id:this.$route.params.activite,
      groupe:this.$route.params.groupe
    }
  },
  methods: {
    editActivity(){
      this.$router.push({ name: 'edit-manager' , params:{groupe:this.groupe,activite:this.activite_id}});
    },

    cloturerActivite(){
      let args = {
        activite: this.activite_id
      };
      let successMessage = this.$i18n.t('message.activite.cloture');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };
      this.$store.dispatch("cloturerActivite", {args, errorMessages, successMessage});
    },

    deleteActivite(){
      let args = {
        activite: this.activite_id
      };
      let successMessage = this.$i18n.t('message.activite.delete');
      let errorMessages = {
        generic: this.$i18n.t('message.genericError'),
        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
      };
      this.$store.dispatch("deleteActivite", {args, errorMessages, successMessage});
    },

    getDescription(item){
      return item.description;
    },

    getNomPatient(item){
      let patient =        _.find(this.mPatients, function (patient){
        return patient.id == item
      })

      if (patient){
        return  patient.text;
      }
      return '';
    },

    getActivite() {
      let args = {
        activite: this.activite_id
      };

      this.$store.dispatch("getActivite", {args});
    },
  },

  mounted() {
    this.getActivite();
  }
}
</script>

<style scoped>

</style>